import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  Button, Dialog, DialogContent, DialogActions,
} from '../../../common/components';

const S = {
  Dialog: styled(Dialog)`
    .paper {
      width: 480px;
    }
  `,
  Paragraph: styled.p`
    margin-bottom: 40px;
    color: ${({ theme }) => theme.palette.grey[900]};
    font-size: ${({ theme }) => theme.typography.pxToRem(15)};
    line-height: 1.53;
  `,
  CancelButton: styled(Button)`
    min-height: 40px;
    color: ${({ theme }) => theme.palette.grey[700]};
    font-size: ${({ theme }) => theme.typography.pxToRem(15)};
  `,
  SaveButton: styled(Button)`
    min-height: 40px;
    font-size: ${({ theme }) => theme.typography.pxToRem(15)};
  `,
};

const ConfirmDialog = ({
  count, group, open, onClose,
}) => (
  <S.Dialog open={open} onClose={onClose} disablePortal>
    <DialogContent>
      <S.Paragraph>
        {`선택한 '${group}' 그룹으로 연락처 ${count}건이 추가됩니다.`}
        <br />
        계속하시겠습니까?
      </S.Paragraph>
    </DialogContent>
    <DialogActions>
      <S.CancelButton type="button" variant="outlined" onClick={onClose}>
        취소
      </S.CancelButton>
      <S.SaveButton type="submit" color="primary" variant="contained">
        확인
      </S.SaveButton>
    </DialogActions>
  </S.Dialog>
);

ConfirmDialog.propTypes = {
  count: PropTypes.number,
  group: PropTypes.string,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
};

ConfirmDialog.defaultProps = {
  count: 0,
  group: '',
  onClose: () => {},
};

export default ConfirmDialog;
